<template>
<div class="col-sm-3" id="right-nav-bar">
    <product-navigation v-if="showProductCategoryNavigation===true"></product-navigation>
    <div class="left-sidebar">
        <p class="centre top-and-bottom-padded">
            <img src="/static/images/dandm/mastercard.gif" alt="We Accept Mastercard"> <img src="/static/images/dandm/visadelta.gif" alt="We Accept Visa Delta"> <img src="/static/images/dandm/maestro.gif" alt="We Accept Maestro"> <img src="/static/images/dandm/jcb.gif" alt="We Accept JBC">
        </p>
        <p class="bold link-text">
        <span class="link-text">Member of the PBFA</span><a href="https://www.pbfa.org/members/d-m-books" target="_new"><img src="/static/images/dandm/pbfa.gif" class="img-responsive inline-img" alt=""></a>
        </p>
    </div>
    <div class="left-sidebar">
        <div class="top-and-bottom-padded">
            <p class="centre">&nbsp;</p>
        </div>
        <h2>Contact Us</h2>
        <div class="contactdetails">
            <p>
                D&M Books,<br />
                5A Knowl Road,<br />
                Mirfield,<br />
                West Yorkshire.<br />
                WF14 8DQ<br />
                UK
            </p>
            <p>
                UK <br />
                <i class="fa fa-phone"></i>
                01924 495768<br />
                <i class="fa fa-fax"></i>
                01924 491267
            </p>
            <p>
                International <br />
                <i class="fa fa-phone"></i>
                +44 1924 495768<br />
                <i class="fa fa-fax"></i>
                +44 1924 491267<br />
            </p>
            <p>
                <i class="fa fa-envelope"></i>
                <a href="mailto:daniel@dandmbooks.com">daniel@dandmbooks.com</a>
            </p>
        </div>
    </div>
  </div>
</template>

<script>
import ProductNavigation from './ProductNavigation';

export default {
  name: 'right-sidebar',
  props: ['showBasket', 'showProductCategoryNavigation'],
  components: {
    'product-navigation': ProductNavigation,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/LeftSidebar.vue